import styled from "styled-components";
import { Color } from "../Color/Color";
import { Flex } from "../Box/Box";

export const IconBox = styled(Flex)<{ $bg?: string; $size?: number }>`
  width: ${({ $size = 40 }) => $size}px;
  height: ${({ $size = 40 }) => $size}px;
  min-width: ${({ $size = 40 }) => $size}px;
  border-radius: ${({ $size = 40 }) => ($size > 40 ? 12 : 8)}px;
  background: ${({ $bg = Color.primary }) => $bg};
  align-items: center;
  justify-content: center;
`;
